import React, { useCallback, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { feedbackTagChipSelectedStyles, feedbackTagChipStyles } from '../GenerateExpression.styles';
import { GenerateExpressionTestIds } from '../GenerateExpression.testIds';

const FeedbackTagChip = ({ isSelected, label, onToggle, value }) => {
  const onClick = useCallback(() => onToggle(value), [onToggle, value]);

  const onKeyDown = useCallback(
    event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onToggle(value);
      }
    },
    [onToggle, value],
  );

  const chipStyles = useMemo(
    () => ({ ...feedbackTagChipStyles, ...(isSelected ? feedbackTagChipSelectedStyles : {}) }),
    [isSelected],
  );

  return (
    <Box
      aria-pressed={isSelected}
      data-testid={GenerateExpressionTestIds.MODAL_FEEDBACK_TAG}
      role="button"
      sx={chipStyles}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <Typography color="text.primary" variant="regular14">
        {label}
      </Typography>
    </Box>
  );
};

FeedbackTagChip.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default FeedbackTagChip;
